export default __webpack_public_path__ + "static/media/2.962d2bf7.webp";